import "./ShowAll.scss";
import { useEffect, useState } from "react";
import { getSearch } from "../../../services/products";
import { useCookies } from "react-cookie";
import { useNavigate, useSearchParams } from "react-router-dom";
import InfoMessage from "../../InfoMessage/InfoMessage";
import { useTranslation } from "react-i18next";
import Loading from "../Loading/Loading";

export default function ShowAll({
  cart,
  setCart,
  showMessage,
  setShowMessage,
}) {
  const { t } = useTranslation();
  const [cookie] = useCookies(["access_token"]);
  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const [convertedPrices, setConvertedPrices] = useState([]);

  useEffect(() => {
    if (!Array.isArray(products) || products.length === 0) return;

    const fetchConvertedPrices = async () => {
      const prices = await Promise.all(
        products?.map((product) =>
          product?.price
            ? Number(product.price) * 1.95583
            : Promise.resolve(null),
        ),
      );
      setConvertedPrices(prices);
    };

    fetchConvertedPrices();
  }, [products]);

  useEffect(() => {
    let timer;
    if (showTooltip) {
      timer = setTimeout(() => {
        setShowTooltip(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [showTooltip]);

  const getSearchProducts = async () => {
    setLoading(true);
    const result = await getSearch(
      cookie?.access_token,
      searchParams.get("search"),
    );
    if (result?.meals?.length > 0 || result?.comboMeals?.length > 0) {
      setProducts(result?.meals.concat(result?.comboMeals));
    } else {
      setProducts([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    getSearchProducts();
  }, [searchParams]);

  return (
    <div className="search-show-all">
      {showMessage && <InfoMessage></InfoMessage>}
      <div className="top">
        {window.screen.width >= 767 && (
          <div
            className="back"
            onClick={() => {
              navigate(`/`);
            }}
          >
            <div className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="8"
                viewBox="0 0 23 8"
                fill="none"
              >
                <path
                  d="M5.83337 4H22.1667"
                  stroke="#343434"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M0.357288 3.78563L4.62174 1.22696C5.15496 0.907026 5.83333 1.29112 5.83333 1.91295V6.08705C5.83333 6.70888 5.15496 7.09297 4.62174 6.77304L0.357289 4.21437C0.195454 4.11727 0.195454 3.88273 0.357288 3.78563Z"
                  fill="#343434"
                />
              </svg>
            </div>

            <div className="text">
              <p>Обратно към Начало</p>
            </div>
          </div>
        )}
        <div className="title">{`"${searchParams.get("search")}"`}</div>
      </div>
      <div className="all-items">
        {products?.length === 0 && loading ? (
          <Loading />
        ) : (
          <>
            {products?.map((product, index) => {
              return (
                <div className="single-item">
                  <div
                    className="item-image"
                    onClick={() => {
                      product?.isCombo
                        ? (window.location.href = `/menu/category/12/subcategory/combos/product/${product.id}`)
                        : product?.category?.id !== undefined
                          ? (window.location.href = `/menu/category/${product?.category?.id}/product/${product.id}`)
                          : (window.location.href = `/menu/product/${product.id}`);
                    }}
                  >
                    {product?.images[0]?.url ? (
                      <img src={product?.images[0]?.url} alt={product.name} />
                    ) : (
                      <img
                        src="https://alexfish-static.s3.eu-north-1.amazonaws.com/missing.svg"
                        alt={product.name}
                      />
                    )}
                  </div>
                  <div
                    className="title"
                    onClick={() => {
                      product?.isCombo
                        ? (window.location.href = `/menu/category/12/subcategory/combos/product/${product.id}`)
                        : product?.category?.id !== undefined
                          ? (window.location.href = `/menu/category/${product?.category?.id}/product/${product.id}`)
                          : (window.location.href = `/menu/product/${product.id}`);
                    }}
                  >
                    <p>
                      {product.name}
                      <span> {product?.weight && `${product.weight}г`}</span>
                    </p>
                  </div>
                  {product?.promoPrice === null ||
                  product?.promoPrice === undefined ? (
                    <div className="price">
                      <p>
                        {Number(product.price)?.toFixed(2)}€/
                        {convertedPrices.length > index &&
                        convertedPrices[index] !== null
                          ? convertedPrices[index]?.toFixed(2) + t("lv")
                          : "Converting..."}
                      </p>
                    </div>
                  ) : (
                    <div className="price">
                      <p className="new">
                        {Number(product.promoPrice)?.toFixed(2)}€
                      </p>
                      <p className="old">
                        {Number(product.price)?.toFixed(2)}€
                      </p>
                    </div>
                  )}
                  <div
                    className={`add-to-cart 
                 ${`/*!isActive ? "disabled" : ""*/`}
                `}
                  >
                    {/* {!isActive && (
                  <p
                    className={`${
                      showTooltip ? "visible" : ""
                    } sushi-available`}
                  >
                    {t("sushi-available")}
                  </p>
                )} */}
                    <button
                      // disabled={!isActive}
                      // onMouseOver={() => !isActive && setShowTooltip(true)}
                      // onMouseLeave={() => !isActive && setShowTooltip(false)}
                      onClick={() => {
                        if (typeof window.gtag === "function") {
                          window.gtag("event", "add_to_cart", {
                            currency: "EUR",
                            value: product?.price,
                            items: [product],
                          });
                        } else {
                          console.error("gtag is not defined!");
                        }
                        setShowMessage(true);
                        if (!product?.isCombo) {
                          let existing = false;
                          cart?.map((item) => {
                            if (
                              item.id === product.id &&
                              item.weight === product.weight
                            ) {
                              existing = true;
                            }
                          });
                          if (existing) {
                            setCart((currentCart) =>
                              currentCart?.map((item) =>
                                item.id === product.id
                                  ? { ...item, amount: item.amount + 1 }
                                  : item,
                              ),
                            );
                          } else {
                            setCart([
                              ...cart,
                              {
                                ...product,
                                added: [],
                                removed: [],
                                amount: 1,
                                price:
                                  product?.promoPrice !== null
                                    ? product?.promoPrice
                                    : product?.price,
                                singlePrice:
                                  product?.promoPrice !== null
                                    ? product?.promoPrice
                                    : product?.price,
                                isCombo: false,
                                weight: product?.weight || product?.minWeight,
                              },
                            ]);
                          }
                        } else {
                          let existing = false;
                          cart?.map((item) => {
                            if (item.id === product.id) {
                              existing = true;
                            }
                          });
                          if (existing) {
                            setCart((currentCart) =>
                              currentCart?.map((item) =>
                                item.id === product.id
                                  ? { ...item, amount: item.amount + 1 }
                                  : item,
                              ),
                            );
                          } else {
                            setCart([
                              ...cart,
                              {
                                ...product,
                                amount: 1,
                                price: product?.price,
                                singlePrice: product?.price,
                                isCombo: true,
                              },
                            ]);
                          }
                        }
                      }}
                    >
                      {t("add")}
                    </button>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
      {products?.length === 0 && !loading && (
        <div className="no-products">
          <p>Няма намерени резултати.</p>
        </div>
      )}
    </div>
  );
}
